import React, { useState, useEffect } from 'react';
import axiosPost from '../helpers/axios-helper';

import '../styles/Home.css';
import { MdChevronRight } from 'react-icons/md';
import { FaMapPin } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import EventCalendar from '../components/EventCalendar';

export default function Home() {
  const [articles, setArticles] = useState([]);
  const [destinations, setDestinations] = useState([]);

  const slugify = (str) => {
    try {
      return (str || '')
        .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .replace(/&/g, ' and ')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
    } catch { return ''; }
  };

  // Fetch countries
  useEffect(() => {
    const controller = new AbortController();
    axiosPost(
      'countries/list',
      {},
      {},
      (res) => {
        const list = Array.isArray(res) ? res : (res?.data || []);
        const mapped = list.map((c, i) => ({
          id: c.id ?? i + 1,
          name: c.name || c.title || '-',
          image: c.image || ''
        }));
        setDestinations(mapped);
      },
      controller
    );
    return () => controller.abort();
  }, []);

  // Fetch latest 4 articles
  useEffect(() => {
    const controller = new AbortController();
    axiosPost(
      'articles/list',
      {},
      {
        status: 'published',
        per_page: 4,
        sort: 'date_published',
        order: 'desc'
      },
      (res) => {
        const items = res?.data?.items || [];
        const mapped = items.map((article) => ({
          id: article.id,
          title: article.title || '',
          description: article.excerpt || '',
          author: article.author || 'OutCaribbean',
          image: article.featured_image_url || '',
          slug: article.slug || ''
        }));
        setArticles(mapped);
      },
      controller
    );
    return () => controller.abort();
  }, []);


  const renderArticles = () => {
    if (!articles || articles.length === 0) {
      return (
        <div className='articles'>
          <div style={{ padding: '40px', textAlign: 'center', color: '#666' }}>
            Loading articles...
          </div>
        </div>
      );
    }

    const highlight = articles[0];

    const list_articles = articles.filter((article, index) => index > 0).map((article, index) => {
      const articleLink = article.slug ? `/article/${article.slug}` : `/blog?id=${article.id}`;
      
      return (
        <Link key={article.id} className='article-list-item' to={articleLink}>
          <div className='article-item-image' style={{backgroundImage: `url(${article.image})`, backgroundSize: 'cover'}}></div>
          <div className='article-item-info'>
            <div> 
              <div className='article-item-title'>{article.title}</div>
              <div className='article-item-description'>{article.description}</div>
            </div>
            
            <div className='article-item-author'>Written by {article.author}</div>
          </div>
        </Link>
      )
    })

    const highlightLink = highlight.slug ? `/article/${highlight.slug}` : `/blog?id=${highlight.id}`;

    return (
      <div className='articles'>
        <Link to={highlightLink} className='articles-highlight' style={{backgroundImage: `url(${highlight.image})`, backgroundSize: 'cover'}}>
          <div className='article-highlight-overlay'>
            <div className='article-highlight-title'>{highlight.title}</div>
            <div className='article-highlight-description'>{highlight.description}</div>
            <div className='article-highlight-author'>Written by {highlight.author}</div>
          </div>
        </Link>
        <div className='articles-list-container'>
          {list_articles}
        </div>

      </div>
    )


  }

  const renderDestinations = () => {

    const render_destinations = destinations.map((destination, index) => {

      return (
        <Link
          to={`/country/${slugify(destination.name)}`}
          className='destination'
          style={{backgroundImage: `url(${destination.image})`, backgroundSize: 'cover'}}
        >
          <div className='destination-cover'>
            <div className='destination-name-home'>{destination.name}</div>
          </div>
        </Link>
      )
    })

    return (
      <div className='destinations-container'>
        { render_destinations }
      </div>
    )

  }

  return (
    <div>
      <div className='landing-section' style={{backgroundImage: `url(${process.env.PUBLIC_URL + '/assets/landing-bg.png'})`, backgroundSize: 'cover'}}>
        <div className='landing-overlay'>
          <div className='landing-text'>
            THE CARIBBEAN YOU DESERVE. <br/>
            AUTHENTIC. SAFE. UNAPOLOGETICALLY QUEER.
          </div>
        </div>
      </div>

      <div className='home-about-container'>
        <div className='home-about'>
          <div className='home-about-title'>OUR STORY</div>
          <div className='home-about-description'>
            <p style={{fontFamily: 'Playfair Display', fontWeight: 'bold', fontSize: '24px', marginBottom: '12px'}}>Every paradise has a paradox. Ours began in Curaçao.</p>
The Caribbean has always existed in contradiction—a region of breathtaking beauty where turquoise waters lap against shores of profound complexity. For LGBTQ travelers, this paradox becomes personal: How do you explore islands that feel like heaven while navigating the very real question of whether you'll be safe being yourself?
          </div>
        </div>
        
        <div className='home-about-options'>
          <div className='home-about-option'>
            Read More
            <div style={{height: '100%', display: 'flex', alignItems: 'center'}}>
              <MdChevronRight size={20} color='#2c2c2c'/>
            </div>
          </div>
        </div>
      </div>

      {/* <div className='container'>
        <div className='section-title'>Events</div>
        
        <EventCalendar limit={4} />
      </div> */}
      
      <div className='container'>
        <div className='section-title'>Articles</div>

        {renderArticles()}
      </div>

      <div className='container'>
        <div className='section-title'>Destinations</div>
        { renderDestinations() }
      </div>
    </div>
  )
}
